import { Component } from '@angular/core';
import { NxIconComponent } from '@allianz/ng-aquila/icon';
import { TextPipe } from '@ps20-frontend/text-service';

@Component({
  selector: 'ps20-shop-session-expired-page',
  templateUrl: './session-expired-page.component.html',
  imports: [NxIconComponent, TextPipe],
})
export class SessionExpiredPageComponent {}
